import React, { PropsWithChildren, useCallback, useState } from "react";
import NavigationHistoryContext, { INavigationHistoryItem } from "./NavigationHistoryContext";

const NavigationHistoryProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [items, setItems] = useState<INavigationHistoryItem[]>([]);

  const navigate = useCallback((path: string, label: string, clear?: boolean) => {
    if (clear) {
      // Clear history and add the new item
      setItems([{ label, path }]);
      return;
    }

    setItems((prev) => {
      // Check if this path already exists in the history
      const existingIndex = prev.findIndex((item) => item.path === path);

      if (existingIndex !== -1) {
        // If the path exists, truncate the history up to that point and update the label
        const newItems = prev.slice(0, existingIndex + 1);
        newItems[existingIndex] = { label, path };
        return newItems;
      } else {
        // Add new item to history
        return [...prev, { label, path }];
      }
    });
  }, []);

  const clear = useCallback(() => {
    setItems([]);
  }, []);

  const updateCurrentLabel = useCallback((label: string) => {
    setItems((prev) => {
      if (prev.length === 0) return prev;
      const newItems = [...prev];
      newItems[newItems.length - 1] = {
        ...newItems[newItems.length - 1],
        label,
      };
      return newItems;
    });
  }, []);

  return (
    <NavigationHistoryContext.Provider
      value={{
        items,
        navigate,
        clear,
        updateCurrentLabel,
      }}
    >
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export default NavigationHistoryProvider;
